/* SicilyAddict DE - 21/10/2026
   Consegna stimata a intervallo per i prodotti secchi (template "secchi", spediti dalla Sicilia).
   La barra verde ha data-transit (min) e data-transit-max (max): si contano i giorni lavorativi
   (data-ship-days, 1 = lunedi') dopo il giorno dell'ordine. Testo e giorni: Impostazioni tema >
   SicilyAddict DE - PDP prodotti secchi. Le barre dei surgelati (senza data-transit-max) non vengono toccate. */
(function () {
  function initRange(bar) {
    if (bar.dataset.saEtaRange) return;
    bar.dataset.saEtaRange = '1';
    var label = bar.querySelector('[data-sa-eta-label]');
    var cutoff = (bar.dataset.cutoff || '').trim();
    var m = /^(\d{1,2}):(\d{2})$/.exec(cutoff);
    var transitMax = parseInt(bar.dataset.transitMax, 10) || 0;
    if (!label || !transitMax) return;
    var shipDays = (bar.dataset.shipDays || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); }).filter(function (d) { return d >= 1 && d <= 7; });
    if (!shipDays.length) return;
    var transit = parseInt(bar.dataset.transit, 10) || 1;
    var now = new Date();
    var isoDay = function (d) { var w = d.getDay(); return w === 0 ? 7 : w; };
      /* Intervallo (prodotti secchi dalla Sicilia): da "transit" a "transitMax" giorni lavorativi.
         Si contano i giorni lavorativi (quelli in shipDays) dopo il giorno dell'ordine; se c'e' l'orario limite
         ed e' gia' passato, l'ordine conta come fatto il giorno dopo. */
      var base = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      if (m && !(now.getHours() < parseInt(m[1], 10) || (now.getHours() === parseInt(m[1], 10) && now.getMinutes() < parseInt(m[2], 10)))) {
        base.setDate(base.getDate() + 1);
      }
      var addWork = function (start, n) {
        var d = new Date(start.getTime()), c = 0, guard = 0;
        while (c < n && guard < 40) { d.setDate(d.getDate() + 1); guard++; if (shipDays.indexOf(isoDay(d)) !== -1) c++; }
        return d;
      };
      var dMin = addWork(base, Math.min(transit, transitMax)), dMax = addWork(base, Math.max(transit, transitMax));
      var f2 = function (d) {
        try { return new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' }).format(d); }
        catch (e) { return d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
      };
      var range = dMin.getTime() === dMax.getTime() ? f2(dMin) : f2(dMin) + ' - ' + f2(dMax);
      label.textContent = (bar.dataset.text || 'Voraussichtliche Lieferung: {datum}').replace('{datum}', range);
      return;
  }
  function run() { document.querySelectorAll('[data-sa-eta][data-transit-max]').forEach(initRange); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('variant:changed', function () { setTimeout(run, 0); });
  document.addEventListener('shopify:section:load', run);
  /* il tema ridisegna il blocco prezzo/consegna quando cambia la variante: ricalcola sui nuovi elementi */
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 50); }).observe(document.documentElement, { childList: true, subtree: true });
})();
